import { formatNumber } from '@/format';

/** Small helpers shared by the payroll screens (kept apart from the
 *  components so fast refresh keeps working). */

export function kindText(kind: 'REGULAR' | 'OFF_CYCLE'): string {
  return kind === 'OFF_CYCLE' ? 'Off-cycle' : 'Regular';
}

/** Days and hours as plain numbers: "26", "1.5". */
export function dayCount(value: string | null | undefined): string {
  return value === null || value === undefined ? '—' : formatNumber(value);
}
